import { render, staticRenderFns } from "./confirmEmailSuccess.vue?vue&type=template&id=036df1d2"
import script from "./confirmEmailSuccess.vue?vue&type=script&lang=js"
export * from "./confirmEmailSuccess.vue?vue&type=script&lang=js"
import style0 from "./confirmEmailSuccess.vue?vue&type=style&index=0&id=036df1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports